module.exports = __webpack_public_path__ + "media/images/instagram-7bcf47eacfed08cd8df938b7ca3f354e.png";